import React from 'react';
import RepVideos from '../RepVideos';

export default function Admin() {
  return <RepVideos />;
}
